export default __webpack_public_path__ + "static/media/img-19.43786d7a.jpg";